// extracted by mini-css-extract-plugin
export default {"Container":"S40zDhzlinye156IYXZW","Text":"d52XPLnUEj2zGvHoR1nA"};